import { Radio, RadioGroup } from "@material-ui/core";
import clsx from "clsx";
import { ChangeEvent, useId, useRef } from "react";
import { GenericDropdown } from "../GenericDropdown";
import "./styles.scss";
import { RadioOption } from "@hopper-b2b/types";
import { Slot } from "../Slots";

export interface IRadioOptions {
  buttonClassName?: string;
  popoverClassName?: string;
  dropdownLabel: string;
  options: RadioOption[];
  selected: RadioOption["value"];
  setOption: (option: RadioOption["value"]) => void;
  radioLabelPlacement?: "start" | "end";
  showDropdownContentOnly?: boolean;
  groupAriaLabel?: string;
  buttonAriaLabel?: string;
  optionProps?: any;
}

export const RadioDropdown = (props: IRadioOptions) => (
  <Slot
    id="radio-dropdown"
    component={<RadioDropdownInternal {...props} />}
    {...props}
  />
);

const RadioDropdownInternal = ({
  buttonClassName,
  popoverClassName,
  options,
  setOption,
  selected,
  dropdownLabel,
  showDropdownContentOnly,
  groupAriaLabel,
  buttonAriaLabel,
  optionProps,
}: IRadioOptions) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setOption((event.target as HTMLInputElement).value);
  };

  const radioRef = useRef<HTMLLabelElement>(null);

  const listId = `listId${Math.trunc(Math.random() * 10 ** 10)}`;
  const listButtonId = `listButton${Math.trunc(Math.random() * 10 ** 10)}`;

  const optionId = useId();

  const renderDropdownContent = () => {
    return (
      <RadioGroup
        className={clsx("radio-group", popoverClassName)}
        value={selected}
        onChange={handleChange}
        id={listId}
        tabIndex={-1}
        role="radiogroup"
        aria-label={groupAriaLabel}
      >
        {options.map((option) => {
          const itemId = option.value + optionId;
          return (
            <div
              className={clsx("card-option", {
                "selected-option": selected === option.value,
              })}
              key={option.value}
              id={itemId}
              {...optionProps}
            >
              <div id={itemId} className="card-label">
                {option.label}
              </div>
              <Radio
                value={option.value}
                inputProps={{
                  "aria-labelledby": itemId,
                  "aria-selected": selected === option.value,
                }}
                inputRef={selected === option.value ? radioRef : null}
                color="secondary"
              />
            </div>
          );
        })}
      </RadioGroup>
    );
  };

  return (
    <>
      {!showDropdownContentOnly && (
        <GenericDropdown
          buttonId={listButtonId}
          buttonClassName={clsx("b2b-shop-filter", buttonClassName)}
          popoverClassName={clsx("radio-dropdown-popover", popoverClassName)}
          ariaLabel={buttonAriaLabel}
          dropdownLabel={dropdownLabel}
          dropdownContent={renderDropdownContent()}
        />
      )}
      {!!showDropdownContentOnly && renderDropdownContent()}
    </>
  );
};
